export const createNewUserObject = company => ({
	email: '',
	company
});

export default { createNewUserObject };
